import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { LanguageProvider } from './contexts/LanguageContext';
import TopBanner from './components/TopBanner';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import WhyAgentecfusion from './components/WhyAgentecfusion';
import UseCases from './components/UseCases';
import PlatformArchitecture from './components/PlatformArchitecture';
import IntegrationHub from './components/IntegrationHub';
import TeamTrackRecord from './components/TeamTrackRecord';
import AboutUs from './components/AboutUs';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Privacy from './components/Privacy';
import Terms from './components/Terms';
import SafeClaw from './components/SafeClaw';
import './App.css';

// Home Page Component
function HomePage() {
  return (
    <>
      <Hero />
      <WhyAgentecfusion />
      <UseCases />
      <PlatformArchitecture />
      <IntegrationHub />
      <Contact />
    </>
  );
}

// About Us Page Component
function AboutPage() {
  return (
    <>
      <AboutUs />
      <TeamTrackRecord />
      <Contact />
    </>
  );
}

function App() {
  return (
    <LanguageProvider>
      <Router>
        <div className="App">
          <TopBanner />
          <Navbar />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/safeclaw" element={<SafeClaw />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
          </Routes>
          <Footer />
        </div>
      </Router>
    </LanguageProvider>
  );
}

export default App;
